import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'
import { ComPhoto, NoResult } from "../../../js/ComponentManager";
import { Link } from 'react-router-dom';
/* 개발담당:양유빈
 * 화면기능:소매리스트
 * 세부설명:
*/

export class RtiQstGrp extends Component {
    static displayName = RtiQstGrp.name;

    constructor(props) {
        super(props);
        this.state = {
            QstMgtRetailList:[]
        };
        this.CsName = Big3Common.ContentState;
        this.handleRtiQstList_Click = this.handleRtiQstList_Click.bind(this);
        this.handle_Blur = this.handle_Blur.bind(this);
        this.handle_KpUp = this.handle_KpUp.bind(this);
        this.Org_Name = Big3Common.Util.GetContentState(this.props.ContentState, this.CsName.SearchText, "");
    }
    //초기화
    async componentDidMount() {
        
        document.querySelector("#org_name").value = this.Org_Name;
        await this.CallOrdMgtMstListData();
       
    }
    //주문목록 조회
    async CallOrdMgtMstListData() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Order/QuestionMgr/GetQstMgtRetailList',
                {
                    "org_name": this.Org_Name
                }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.dataTable);
                this.setState({ QstMgtRetailList: DataList });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallOrdMgtMstListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    handle_Blur(event) {
        this.Org_Name = event.target.value;
        event.preventDefault();
    }
    handle_KpUp(event) {
        if (event.keyCode === 13) {
            this.Org_Name = event.target.value;
            this.CallOrdMgtMstListData();
        }
        event.preventDefault();
    }
    handleRtiQstList_Click(event, list) {

        this.props.RenderComponent("RtiQstList", {
            [this.CsName.Union_Uid]: list.union_uid,
            [this.CsName.Whole_Name]: list.retail_org_name,
            [this.CsName.SearchText]: this.Org_Name
        });
        event.preventDefault();
    }
    MgtListrender() {
        const QstMgtRetailList = this.state.QstMgtRetailList;
        return (
            <div>
                {
                    QstMgtRetailList.map(list => 
                        <div className="alert_content" key={list.union_uid}
                            onClick={(e) => { this.handleRtiQstList_Click(e,list) }}
                        >
                            <div className="alert_img">
                                <ComPhoto className="alert_img_in" Photo={list.retail_photo} />
                            </div>
                            <div className="alert_txt">
                                <div className="alert_title">{list.retail_area_nm === "" ? "" : `[${list.retail_area_nm}]`} {list.retail_org_name}</div>
                                <div className="alert_time">{list.qstdt} {list.conf_count === 0 ? "" : <div className="alert_new"></div> }</div>
                            </div>
                        </div>
                    )
                }
            </div>
        )
    }
    render() {
        const MgtListrender = this.MgtListrender();
        return (
            <>
                <div className="tap_box tap_box_v2">
                    <div className="n_tap"><div className="alert_tap tap_on" >주문문의</div></div>
                    <Link to="/Order/LiveChat/LiveChatList">
                        <div className="n_tap">
                            <div className="alert_tap">
                                채팅문의
                                <sup>βeta</sup>
                            </div>
                        </div>
                    </Link>
                    
                </div>
                <div className="container_box m_f_margin d_padding">
                    <div className="search_box  retail_search">
                        <div className="search_input_box">
                            <input type="text" placeholder="소매명을 입력해주세요."
                                className="form-control"
                                maxLength="20"
                                onBlur={(e) => { this.handle_Blur(e); }}
                                onKeyUp={(e) => { this.handle_KpUp(e); }}
                                id="org_name"
                            />
                            <div className="search_btn" onClick={(e) => { this.CallOrdMgtMstListData(); e.preventDefault(); }}></div>
                        </div>
                    </div>
                    {MgtListrender}
                    <NoResult
                        Visible={this.state.QstMgtRetailList.length === 0 ? true : false}
                        Top={"60%"}
                    />
                </div>
            </>
        );
    }
}
